<template lang="pug">
div.wrap-module-parent-asset-selector.relative.rounded.overflow-hidden
  div.wrap-header.absolute.w-full.l0.t0
    HeaderModalWindow(label="メインアセットを選択"
      @closeModalWindow="$emit('closeModalWindow')")
  div(ref="wrapAssets").wrap-assets.overflow-scroll
    div(v-if="assets[0]").selector-content
      div(v-for="asset in assets" :key="asset.id"
        @click.stop="onCard(asset)").card-asset.f.fm.cursor-pointer
        div.wrap-asset-img.f.fh.mr20.overflow-hidden
          img(:src="asset.mainImg").h-full.object-fit-cover
        div
          span.fz16.bold.mb4 {{asset.name}}
          div.wrap-type.f.fm.mb8
            v-icon(size="16px").mr4 {{getIconByAssetType(asset.type)}}
            span.fz14 {{getNameByAssetType(asset.type)}}
          div.wrap-tags.f.flex-wrap
            span(v-for="tag in asset.tags").tag.fz12.px8.py4.mr8.mb8.rounded {{tag}}
    div(v-else).wrap-no-asset.f.fh
      span(v-if="isInitialized").fz16 選択可能なアセットがありません
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$modal_header_height: 44px;
.wrap-module-parent-asset-selector {
  background: $primary-bg-color;
  .wrap-header {
    z-index: 101;
    max-width: $base_max_width_px;
  }
  .wrap-assets {
    padding-top: $modal_header_height;
    width: 92vw;
    max-width: $base_max_width_px;
    max-height: 95vh;
    .card-asset {
      border-bottom: $basic_border;
      .wrap-asset-img {
        width: 200px;
        height: 120px;
      }
      .wrap-tags {
        .tag {
          border: $basic_border;
        }
      }
    }
    .wrap-no-asset {
      height: 50vh
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import HeaderModalWindow from '@/components/shared/HeaderModalWindow'

export default {
  components: { HeaderModalWindow },
  computed: {
    ...mapStateAuth(['uid'])
  },
  props: {
    childAsset: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      assets: [],
      isLoading: false,
      oldestDateOfAssetSeconds: new Date().getTime() / 1000,
      loadMoreAssets: true,
      loadLimit: 10,
      isInitialized: false
    }
  },
  async created () {
    await this.loadAssets()
    this.isInitialized = true
  },
  mounted () {
    this.$refs.wrapAssets.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    this.$refs.wrapAssets.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const wrapAssets = this.$refs.wrapAssets
      if (wrapAssets.scrollHeight - wrapAssets.clientHeight <= wrapAssets.scrollTop + 10) {
        this.loadAssets()
      }
    },
    async loadAssets () {
      if (!this.loadMoreAssets) return
      this.isLoading = true
      let newAssets = await database.assetCollection()
        .getUserAssets({ 
          uid: this.uid,
          seconds: this.oldestDateOfAssetSeconds,
          isMyPage: this.uid === this.$route.params.uid,
          limit: this.loadLimit
        })
      if (newAssets[0]) {
        if (this.childAsset) {
          newAssets = newAssets.filter(a => a.id !== this.childAsset.id)
        }
        this.assets = this.assets.concat(newAssets)
        this.oldestDateOfAssetSeconds = newAssets[newAssets.length - 1].createdAt._seconds
      } else {
        this.loadMoreAssets = false
      }
      this.isLoading = false
    },
    onCard (asset) {
      this.$refs.wrapAssets.removeEventListener('scroll', this.onScroll)
      this.$emit('setParentAsset', asset)
      this.$emit('openAddAset')
      this.$emit('closeModalWindow')
    }
  }
}
</script>
